/**
 * ///////////////////////////////////////////////////////////////////////////////
 * //            _                                            _       	        //
 * //           | |                                          | |      	        //
 * // 	        | |__  _   _    __ ___   _____   ___ __ _  __| | ___  	        //
 * // 	        | '_ \| | | |  / _` \ \ / / _ \ / __/ _` |/ _` |/ _ \           //
 * // 	        | |_) | |_| | | (_| |\ V / (_) | (_| (_| | (_| | (_) |	        //
 * // 	        |_.__/ \__, |  \__,_| \_/ \___/ \___\__,_|\__,_|\___/ 	        //
 * //         	        __/ |                                         	        //
 * //        	       |___/                                          	        //
 * //                                                                           //
 * ///////////////////////////////////////////////////////////////////////////////
 * 
 * jQuery und Bootstrap Plugin für Pagination
 * 
 * @author Christian Dreher
 * @see http://stash.avocado-se.local:7990/projects/AV/repos/avcpaginator
 */

!function($)
{
    "use strict";

    /**
     * Konstruktor
     */
    function AvcPaginator(table, options)
    {
        // Lädt und initialisiert die Optionen
        this.options = this.getOptions(options);

        // Pointer auf die Tabelle an sich
        this.$table = $(table);

        // Containerbereich für den Paginator erzeugen
        this.buildAvcPaginatorContainer();

        // Eventhandler auf die Buttons registrieren
        this.registerEventHandler();

        // Initialisiert aktuelle Seite
        this.currentPage = this.options.startPage;

        // Setzt {$rows}
        this.setRows();

        // Anzahl der Seiten berechnen
        this.setPages();

        // Tabelle aktualisieren (Überflüssige Zeilen verstecken)
        this.updateTable();

        // Paginator aufbauen
        this.buildAvcPaginator();
    }

    /**
     * Prototype
     */
    AvcPaginator.prototype =
    {
        /**
         * Standardwerte
         */
        defaults:
        {
            labelFirstPage: '<i class="icon-step-backward"></i>',
            labelPreviousPage: '<i class="icon-backward"></i>',
            labelNextPage: '<i class="icon-forward"></i>',
            labelLastPage: '<i class="icon-step-forward"></i>',
            buttonClasses: 'btn',
            paginatorTop: true,
            paginatorBottom: true,
            rowsPerPage: 10,
            pagesToShow: 5,
            startPage: 1,
            theadAlwaysVisible: true
        },

        /**
         * Konstruktor übergeben
         */
        constructor: AvcPaginator,

        /**
         * Merged die übergebenen Parameter an den Paginator mit den Defaults
         * @param options Übergebene Optionen
         * @returns Defaultwerte mit überschriebenen übergebenen Optionen
         */
        getOptions: function(options)
        {
            return $.extend({}, this.defaults, options);
        },

        /**
         * Registriert die benötigten Eventhandler für die Paginatatorbuttons
         */
        registerEventHandler: function()
        {
            // Pointer auf den Paginator
            var avcPaginator = this;

            this.$container.on('click', 'button:not(.disabled)', function()
            {
                var name = $(this).attr('name');
                var action = name.substring(name.lastIndexOf('-') + 1);

                if (action === 'first') // Erste Seite geklickt?
                {
                    avcPaginator.currentPage = 1;
                }
                else if (action === 'previous') // Vorherige Seite geklickt?
                {
                    avcPaginator.currentPage--;
                }
                else if (action === 'next') // Nächste Seite geklickt?
                {
                    avcPaginator.currentPage++;
                }
                else if (action === 'last') // Letzte Seite geklickt?
                {
                    avcPaginator.currentPage = avcPaginator.pages;
                }
                else // {action} ist in diesem Fall ein int mit der geklickten Seitenzahl
                {
                    var page = parseInt(action);

                    // NaN-Fehlerfall abfangen
                    if (isNaN(page))
                    {
                        page = 1;
                    }

                    avcPaginator.currentPage = page;
                }

                avcPaginator.updateTable();
                avcPaginator.buildAvcPaginator();
            });
        },

        /**
         * Bezieht je nach Einstellung die benötigten Zeilen und setzt die Variable {$rows}
         */
        setRows: function()
        {
            // Option: theadAlwaysVisible gesetzt?
            if (this.options.theadAlwaysVisible)
            {
                this.$rows = this.$table.find('tbody').find('tr');
            }
            else
            {
                this.$rows = this.$table.find('tr');
            }
        },

        /**
         * Berechnet die benötigte Seitenanzahl und setzt die Variable {pages}
         */
        setPages: function()
        {
            this.pages = Math.max(Math.ceil(this.$rows.length / this.options.rowsPerPage), 1);
        },

        /**
         * Aktualisiert die Tabelle und versteckt die Zeilen die auf der aktuellen
         * Seite nicht sichtbar sein sollen
         */
        updateTable: function()
        {
            var i = 0;
            var from = (this.currentPage - 1) * this.options.rowsPerPage;
            var to = from + this.options.rowsPerPage;

            this.$rows.each(function()
            {
                if (i < from || i >= to)
                {
                    $(this).addClass('avc-paginator-hide');
                }
                else
                {
                    $(this).removeClass('avc-paginator-hide');
                }

                i++;
            });
        },

        /**
         * Erzeugt Container für den/die Paginator/s
         */
        buildAvcPaginatorContainer: function()
        {
            if (this.options.paginatorTop)
            {
                this.$table.before('<div class="avc-paginator-container btn-group"></div>');
            }

            if (this.options.paginatorBottom)
            {
                this.$table.after('<div class="avc-paginator-container btn-group"></div>');
            }

            this.$container = this.$table.siblings('.avc-paginator-container');
        },

        /**
         * Aufbau des Paginators der Form:
         * Erste Seite | Vorherige Seite | Seiten... | Nächste Seite | Letzte Seite
         */
        buildAvcPaginator: function()
        {
            this.$container.html('');

            if (this.pages > 1)
            {
                this.$container.css('display', 'block');
                
                // Tokens sind die Anzahl an Seitenbuttons, die
                // vergeben werden dürfen.
                var tokens = (this.options.pagesToShow > this.pages) ? this.pages : this.options.pagesToShow;

                // Baut die Seitenbuttons auf
                for (var i = 0; tokens !== 0; i++)
                {
                    if (i === 0)
                    {
                        this.$container.append('<button class="' + this.options.buttonClasses + ' disabled" name="avc-paginator-goto-' + this.currentPage + '">' + this.currentPage + '</button>');
                        tokens--;
                    }
                    else
                    {
                        if (this.currentPage + i <= this.pages)
                        {
                            this.$container.append('<button class="' + this.options.buttonClasses + '" name="avc-paginator-goto-' + (this.currentPage + i) + '">' + (this.currentPage + i) + '</button>');
                            tokens--;
                        }

                        if (this.currentPage - i > 0)
                        {
                            this.$container.prepend('<button class="' + this.options.buttonClasses + '" name="avc-paginator-goto-' + (this.currentPage - i) + '">' + (this.currentPage - i) + '</button>');
                            tokens--;
                        }
                    }
                }

                // Baut die Navigationsbuttons auf
                this.$container.prepend('<button class="' + this.options.buttonClasses + '" name="avc-paginator-goto-previous">' + this.options.labelPreviousPage + '</button>');
                this.$container.prepend('<button class="' + this.options.buttonClasses + '" name="avc-paginator-goto-first">' + this.options.labelFirstPage + '</button>');
                this.$container.append('<button class="' + this.options.buttonClasses + '" name="avc-paginator-goto-next">' + this.options.labelNextPage + '</button>');
                this.$container.append('<button class="' + this.options.buttonClasses + '" name="avc-paginator-goto-last">' + this.options.labelLastPage + '</button>');

                // Prüft, ob die aktuelle Seite die erste oder letzte Seite ist
                // und deaktiviert die dementsprechenden Buttons
                if (this.currentPage === 1)
                {
                    this.$container.find('button[name="avc-paginator-goto-previous"], button[name="avc-paginator-goto-first"]').addClass('disabled');
                }
                else if (this.currentPage === this.pages)
                {
                    this.$container.find('button[name="avc-paginator-goto-next"], button[name="avc-paginator-goto-last"]').addClass('disabled');
                }
            }
            else
            {
                this.$container.css('display', 'none');
            }
        },

        /**
         * Aktualisiert die Daten über die Tabelle. Nur benötigt, wenn sich die Anzahl 
         * der Zeilen ändert.
         */
        refresh: function()
        {
            // Falls aktuelle Seite größer ist als die
            // eigentliche Anzahl an Seiten (tritt auf,
            // wenn Zeilen entfernt wurden)
            if (this.currentPage > this.pages)
            {
                this.currentPage = this.pages;
            }

            // {$rows} neu setzen
            this.setRows();

            // Anzahl der Seiten neu berechnen
            this.setPages();

            // Tabelle aktualisieren (Überflüssige Zeilen verstecken)
            this.updateTable();

            // Paginator aufbauen
            this.buildAvcPaginator();
        }
    };

    /**
     * Registriert das Plugin bei jQuery
     */
    $.fn.avcPaginator = function(option, parameter)
    {
        return this.each(function()
        {
            var data = $(this).data('avcPaginator');
            var options = typeof option === 'object' && option;

            // Initialisiert den Paginator
            if (!data)
            {
                $(this).data('avcPaginator', (data = new AvcPaginator(this, options)));
            }

            if (typeof option === 'string')
            {
                data[option](parameter);
            }
        });
    };

    $.fn.avcPaginator.Constructor = AvcPaginator;
}
(window.jQuery);